import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { MasterDataStatusFilter, ActivationResult } from '../interfaces/masterDataStatus.interface';
import { Customer, CustomerCreateDTO, CustomerPage } from '../interfaces/sales/customer.interface';

export const CustomerService = {
  // FW-1: status omitted = ACTIVE (pickers for NEW documents); pass 'ALL' for list pages, reports and filters.
  listByInstitution: async (institutionId: string, page = 0, size = 10, status?: MasterDataStatusFilter,
    owner: { salespersonId?: string; unassigned?: boolean } = {}): Promise<CustomerPage> =>
    (await axios.get(`${ENDPOINTS.CUSTOMER.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}${status ? `&status=${status}` : ''}`,
      { params: owner })).data,
  deactivate: async (id: string, reason?: string): Promise<ActivationResult> =>
    (await axios.post(ENDPOINTS.CUSTOMER.DEACTIVATE(id), { reason: reason?.trim() || undefined })).data,
  activate: async (id: string): Promise<ActivationResult> => (await axios.post(ENDPOINTS.CUSTOMER.ACTIVATE(id))).data,
  getById: async (id: string): Promise<Customer> =>
    (await axios.get(ENDPOINTS.CUSTOMER.GET_BY_ID(id))).data,
  create: async (dto: CustomerCreateDTO): Promise<Customer> =>
    (await axios.post(ENDPOINTS.CUSTOMER.CREATE, dto)).data,
  update: async (id: string, dto: CustomerCreateDTO): Promise<Customer> =>
    (await axios.put(ENDPOINTS.CUSTOMER.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.CUSTOMER.DELETE(id))).data,
};
